import React from "react";
import { Box, Typography } from "@mui/material";
import PackageCard from "./PackageCard";

const PackagesList: React.FC = () => {
  const packages = [
    {
      name: "Muzkuru Pro",
      isRecommended: true,
      price: 699.0,
      subtitle: "Your Selected Package",
      features: [
        "3 Camera Professional Shoot",
        "Professional Audio Recording",
        "Full Day Coverage",
        "PA System Included",
        "Live Streaming Capability",
        "Edited Video Highlights",
      ],
    },
    {
      name: "Muzkuru X",
      isRecommended: false,
      price: 499.0,
      subtitle: "Alternative Package Option",
      features: [
        "2 Camera Professional Shoot",
        "Full Day Coverage",
        "Professional Audio Recording",
        "Edited Video Highlights",
      ],
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Available Packages
      </Typography>

      <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        {packages.map((pkg, index) => (
          <PackageCard key={index} {...pkg} />
        ))}
      </Box>
    </Box>
  );
};

export default PackagesList;
